import { MetrixThemeProvider } from 'metrix-common3';
import { useMemo } from 'react';

const AppWithConstants = ({ children }) => {
    const envConstants = useMemo(
        () => ({
            colors: {
                Primary: import.meta.env.VITE_Colors_Primary,
                Secondary: import.meta.env.VITE_Colors_Secondary,
                Tertiary: import.meta.env.VITE_Colors_Tertiary,
                PrimaryText: import.meta.env.VITE_Colors_PrimaryText,
                SecondaryText: import.meta.env.VITE_Colors_SecondaryText,
                TertiaryText: import.meta.env.VITE_Colors_TertiaryText,
                BrandAvatarColor: import.meta.env.VITE_Colors_BrandAvatarColor,
                MenuTextColor: import.meta.env.VITE_Colors_MenuTextColor,
                MenuButtonColor: import.meta.env.VITE_Colors_MenuButtonColor,
                MenuListColor: import.meta.env.VITE_Colors_MenuListColor,
                MenuListBgColor: import.meta.env.VITE_Colors_MenuListBgColor,
                MoreButtonColor: import.meta.env.VITE_Colors_MoreButtonColor,
                MoreButtonHoverColor: import.meta.env.VITE_Colors_MoreButtonHoverColor,
                MenuFooter: import.meta.env.VITE_Colors_MenuFooter,
                ArticleCircleBg: import.meta.env.VITE_Colors_ArticleCircleBg,
                SecondaryLight: import.meta.env.VITE_Colors_SecondaryLight,
                StrokeVeryDark: import.meta.env.VITE_Colors_StrokeVeryDark,
                StrokeDark: import.meta.env.VITE_Colors_StrokeDark,
                StrokeMedium: import.meta.env.VITE_Colors_StrokeMedium,
                StrokeLight: import.meta.env.VITE_Colors_StrokeLight,
                StrokeVeryLight: import.meta.env.VITE_Colors_StrokeVeryLight,
                LightMode: import.meta.env.VITE_Colors_LightMode,
                DarkMode: import.meta.env.VITE_Colors_DarkMode,
                Error: import.meta.env.VITE_Colors_Error,
                Warning: import.meta.env.VITE_Colors_Warning,
                Success: import.meta.env.VITE_Colors_Success,
                Link: import.meta.env.VITE_Colors_Link,
                HeaderBarBackground: import.meta.env.VITE_Colors_HeaderBarBackground,
            },
            alignments: {
                none: import.meta.env.VITE_Alignments_none,
                center: import.meta.env.VITE_Alignments_center,
                top: import.meta.env.VITE_Alignments_top,
                bottom: import.meta.env.VITE_Alignments_bottom,
                left: import.meta.env.VITE_Alignments_left,
                right: import.meta.env.VITE_Alignments_right,
            },
            sizes: {
                none: import.meta.env.VITE_Sizes_none,
                xxs: import.meta.env.VITE_Sizes_xxs,
                xs: import.meta.env.VITE_Sizes_xs,
                sm: import.meta.env.VITE_Sizes_sm,
                md: import.meta.env.VITE_Sizes_md,
                lg: import.meta.env.VITE_Sizes_lg,
                xl: import.meta.env.VITE_Sizes_xl,
                xxl: import.meta.env.VITE_Sizes_xxl,
                xxxl: import.meta.env.VITE_Sizes_xxxl,
            },
            opacity: {
                None: import.meta.env.VITE_Opacity_None,
                UltraDark: import.meta.env.VITE_Opacity_UltraDark,
                VeryDark: import.meta.env.VITE_Opacity_VeryDark,
                Darker: import.meta.env.VITE_Opacity_Darker,
                Dark: import.meta.env.VITE_Opacity_Dark,
                Medium: import.meta.env.VITE_Opacity_Medium,
                Light: import.meta.env.VITE_Opacity_Light,
                Lighter: import.meta.env.VITE_Opacity_Lighter,
                VeryLight: import.meta.env.VITE_Opacity_VeryLight,
                UltraLight: import.meta.env.VITE_Opacity_UltraLight,
                Full: import.meta.env.VITE_Opacity_Full,
            },
            radius: {
                small: import.meta.env.VITE_Radius_small,
                standard: import.meta.env.VITE_Radius_standard,
                large: import.meta.env.VITE_Radius_large,
                full: import.meta.env.VITE_Radius_full,
            },
            screenSize: {
                xs: import.meta.env.VITE_ScreenSize_xs,
                sm: import.meta.env.VITE_ScreenSize_sm,
                md: import.meta.env.VITE_ScreenSize_md,
                lg: import.meta.env.VITE_ScreenSize_lg,
                xl: import.meta.env.VITE_ScreenSize_xl,
            },
            textSizes: {
                WeightLight: import.meta.env.VITE_TextSizes_WeightLight,
                WeightNormal: import.meta.env.VITE_TextSizes_WeightNormal,
                WeightMedium: import.meta.env.VITE_TextSizes_WeightMedium,
                WeightSemiBold: import.meta.env.VITE_TextSizes_WeightSemiBold,
                LineSpacingBody: import.meta.env.VITE_TextSizes_LineSpacingBody,
                D1FontSize: import.meta.env.VITE_TextSizes_D1FontSize,
                D1FontWeight: import.meta.env.VITE_TextSizes_D1FontWeight,
                D1LineHeight: import.meta.env.VITE_TextSizes_D1LineHeight,
                D2FontSize: import.meta.env.VITE_TextSizes_D2FontSize,
                D2FontWeight: import.meta.env.VITE_TextSizes_D2FontWeight,
                D2LineHeight: import.meta.env.VITE_TextSizes_D2LineHeight,
                D3FontSize: import.meta.env.VITE_TextSizes_D3FontSize,
                D3FontWeight: import.meta.env.VITE_TextSizes_D3FontWeight,
                D3LineHeight: import.meta.env.VITE_TextSizes_D3LineHeight,
                D4FontSize: import.meta.env.VITE_TextSizes_D4FontSize,
                D4FontWeight: import.meta.env.VITE_TextSizes_D4FontWeight,
                D4LineHeight: import.meta.env.VITE_TextSizes_D4LineHeight,
                DisplayFontFamily: import.meta.env.VITE_TextSizes_DisplayFontFamily,
                H0FontSize: import.meta.env.VITE_TextSizes_H0FontSize,
                H0FontWeight: import.meta.env.VITE_TextSizes_H0FontWeight,
                H0LineHeight: import.meta.env.VITE_TextSizes_H0LineHeight,
                H1FontSize: import.meta.env.VITE_TextSizes_H1FontSize,
                H1FontWeight: import.meta.env.VITE_TextSizes_H1FontWeight,
                H1LineHeight: import.meta.env.VITE_TextSizes_H1LineHeight,
                H2FontSize: import.meta.env.VITE_TextSizes_H2FontSize,
                H2FontWeight: import.meta.env.VITE_TextSizes_H2FontWeight,
                H2LineHeight: import.meta.env.VITE_TextSizes_H2LineHeight,
                H3FontSize: import.meta.env.VITE_TextSizes_H3FontSize,
                H3FontWeight: import.meta.env.VITE_TextSizes_H3FontWeight,
                H3LineHeight: import.meta.env.VITE_TextSizes_H3LineHeight,
                H4FontSize: import.meta.env.VITE_TextSizes_H4FontSize,
                H4FontWeight: import.meta.env.VITE_TextSizes_H4FontWeight,
                H4LineHeight: import.meta.env.VITE_TextSizes_H4LineHeight,
                H5FontSize: import.meta.env.VITE_TextSizes_H5FontSize,
                H5FontWeight: import.meta.env.VITE_TextSizes_H5FontWeight,
                H5LineHeight: import.meta.env.VITE_TextSizes_H5LineHeight,
                H6FontSize: import.meta.env.VITE_TextSizes_H6FontSize,
                H6FontWeight: import.meta.env.VITE_TextSizes_H6FontWeight,
                H6LineHeight: import.meta.env.VITE_TextSizes_H6LineHeight,
                HeaderFontFamily: import.meta.env.VITE_TextSizes_HeaderFontFamily,
                P1FontSize: import.meta.env.VITE_TextSizes_P1FontSize,
                P1LineHeight: import.meta.env.VITE_TextSizes_P1LineHeight,
                P2FontSize: import.meta.env.VITE_TextSizes_P2FontSize,
                P2LineHeight: import.meta.env.VITE_TextSizes_P2LineHeight,
                P3FontSize: import.meta.env.VITE_TextSizes_P3FontSize,
                P3LineHeight: import.meta.env.VITE_TextSizes_P3LineHeight,
                P4FontSize: import.meta.env.VITE_TextSizes_P4FontSize,
                P4LineHeight: import.meta.env.VITE_TextSizes_P4LineHeight,
                ParagraphFontFamily: import.meta.env.VITE_TextSizes_ParagraphFontFamily,
                ParagraphLetterSpacing: import.meta.env.VITE_TextSizes_ParagraphLetterSpacing,
                ButtonFontSize: import.meta.env.VITE_TextSizes_ButtonFontSize,
                ButtonLineHeight: import.meta.env.VITE_TextSizes_ButtonLineHeight,
            },
        }),
        [],
    );

    return <MetrixThemeProvider envConstants={envConstants}>{children}</MetrixThemeProvider>;
};

export default AppWithConstants;
